import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_GIPHY_KEY, ASSETS_BASE_URL } from '../../../lib/constants';

type GiphyComponentProps = {
  onHandleClick: (link: string) => any;
};

const GiphyComponent = ({ onHandleClick }: GiphyComponentProps) => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const result = await axios('https://api.giphy.com/v1/gifs/trending', {
          params: {
            api_key: API_GIPHY_KEY,
            limit: 100
          }
        });
        setData(result.data.data);
      } catch (err) {
        setIsError(true);
        setTimeout(() => setIsError(false), 4000);
      }

      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleSearchChange = (event: any) => {
    setSearch(event.target.value);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setIsError(false);
    setIsLoading(true);

    if (search.length > 0) {
      try {
        const result = await axios('https://api.giphy.com/v1/gifs/search', {
          params: {
            api_key: API_GIPHY_KEY,
            q: search,
            limit: 100
          }
        });
        setData(result.data.data);
      } catch (err) {
        setIsError(true);
        setTimeout(() => setIsError(false), 4000);
      }

      setIsLoading(false);
    } else {
      setIsError(true);
    }
  };

  const ShortenGiphyImg = (url: string) => {
    const array = url.split('?');
    onHandleClick(array[0]);
  };

  return (
    <div className="m-2 giphy-contaner">
      {isError ? (
        <div className="mb-2.5">Unable to get, please try again in a few minutes</div>
      ) : null}
      <form className="giphy-form flex flex-row justify-center mb-3">
        <input
          value={search}
          onChange={handleSearchChange}
          type="text"
          placeholder="/* Search GIPHY */"
          className="input-giphy"
        ></input>
        <button onClick={handleSubmit} className="giphy-button-submit">
          <img src={`${ASSETS_BASE_URL}system/cw-assets/search.svg`} />
        </button>
      </form>
      <div className="">
        {isLoading ? (
          <div className="giphy-section">Loading...</div>
        ) : (
          <div className="flex flex-col justify-center overflow-y-scroll giphy-section">
            {data.map((el, i) => {
              return (
                <div
                  key={`${el.id}_${i}`}
                  className="mb-2 self-center"
                  onClick={() => {ShortenGiphyImg(el?.images.original.url)}}
                >
                  <img src={el.images.original.url} className="" />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default GiphyComponent;
